import React from 'react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { Bar } from '@nivo/bar';
import { fmCompactNum, fmNum } from "../common/formatter.jsx";

import { BasicAlert } from '../common/components.jsx';

//----------------------------------------------------------------------
//   OSAnalyticsPage -- show analytics
//
//----------------------------------------------------------------------
export class OSAnalyticsPage extends React.Component {

    constructor(props) {
      super(props);
      this.state = {
        activeView        : "quarter_allOrders",
        quarter_allOrders :  {status : "L", byPeriod : "quarter", periodValues: {}, chartData: {dollar: "", orders : ""}},
        quarter_myOrders  :  {status : "L", periodValues: {}, chartData: {}},
        month_allOrders   :  {status : "L", periodValues: {}, chartData: {}},
        month_myOrders    :  {status : "L", periodValues: {}, chartData: {}},
        orderStatus: "total",
        orderBacklog: "allOrders",
        orderTypeToggle: false,
        errorMessage: ""
      }
      this.fetchData    = this.fetchData.bind(this);
      this.handleSelect = this.handleSelect.bind(this);
      this.handleToggle = this.handleToggle.bind(this);
    }
  
    fetchData() {
      var valueType;
      var orderTypeToggle = this.state.orderTypeToggle;
  
      if (orderTypeToggle) {
        valueType = "orders";
      } else {
        valueType = "dollar";
      }
      
      axios.all([
        axios.post('/os/ossui/v1/ex/widget/analytic', { byPeriod: "quarter", orderBacklog: "allOrders" }),
        axios.post('/os/ossui/v1/ex/widget/analytic', { byPeriod: "quarter", orderBacklog: "myOrders" }), 
        axios.post('/os/ossui/v1/ex/widget/analytic', { byPeriod: "month",   orderBacklog: "allOrders" }),
        axios.post('/os/ossui/v1/ex/widget/analytic', { byPeriod: "month",   orderBacklog: "myOrders" }), 
      ])
      .then(axios.spread((...resp) => {
  
        this.setState({ 
          quarter_allOrders : {status : resp[0].status, byPeriod: resp[0].data.data.xDimension.name.toLowerCase(), orderBacklog: "allOrders", periodValues: resp[0].data.data.xDimension.values, chartData: {dollar : resp[0].data.data.values.dollar, orders : resp[0].data.data.values.orders}},
          quarter_myOrders  : {status : resp[1].status, byPeriod: resp[1].data.data.xDimension.name.toLowerCase(), orderBacklog: "myOrders" , periodValues: resp[1].data.data.xDimension.values, chartData: {dollar : resp[1].data.data.values.dollar, orders : resp[1].data.data.values.orders}},
          month_allOrders   : {status : resp[2].status, byPeriod: resp[2].data.data.xDimension.name.toLowerCase(), orderBacklog: "allOrders", periodValues: resp[2].data.data.xDimension.values, chartData: {dollar : resp[2].data.data.values.dollar, orders : resp[2].data.data.values.orders}},
          month_myOrders    : {status : resp[3].status, byPeriod: resp[3].data.data.xDimension.name.toLowerCase(), orderBacklog: "myOrders" , periodValues: resp[3].data.data.xDimension.values, chartData: {dollar : resp[3].data.data.values.dollar, orders : resp[3].data.data.values.orders}},
        });
  
        toast.success("Updated sucessfully!", {
          position: "bottom-right",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }))
      .catch(error => {
        this.setState({ errorMessage: error.response.statusText });
        toast.error(error.response.statusText, {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }); 
    });
  
    }
  
    componentDidMount() {
      this.fetchData();
    }
  
    componentDidUpdate(prevProps, prevState) {
      if (this.state.orderTypeToggle !== prevState.orderTypeToggle || this.state.byPeriod !== prevState.byPeriod || this.state.valueType !== prevState.valueType || this.state.orderBacklog !== prevState.orderBacklog) {
        //this.fetchData();
      }
    }
  
    handleSelect(e) {
      if (e.target.name == "orderStatusOptions" && this.state.orderStatus != e.target.value ) {
        this.setState({
          orderStatus: e.target.value
        })
      } else if (e.target.name == "periodOptions" && this.state[this.state.activeView].byPeriod != e.target.value) {
        this.setState({
          activeView: e.target.value + "_" + this.state[this.state.activeView].orderBacklog,
        })
      } else if (e.target.name == "orderBacklog" && this.state[this.state.activeView].orderBacklog != e.target.value) {
        this.setState({
          activeView: this.state[this.state.activeView].byPeriod + "_" + e.target.value,
        })
      }
      e.preventDefault();
    }
  
    handleToggle() {
          this.setState({
              orderTypeToggle: !this.state.orderTypeToggle,
          });
      }
    
    //ResponsiveBar
    render() {
  
      var valueType    = "dollar"
      if (this.state.orderTypeToggle) {
        valueType = "orders";
      }
      var orderStatus  = this.state.orderStatus;
      var activeView   = this.state.activeView; 
      var byPeriod     = this.state[activeView].byPeriod.toLowerCase();
      var chartData    = this.state[activeView].chartData[valueType];
      var periodValues = this.state[activeView].periodValues;
      var status       = this.state[activeView].status;
  
      var data       = [];
  
      //convert data returned from /ossui/v1/ex/widget/analytic into nivo bar compatible array
      var newObj = {};
  
      //for (const [key, value] of Object.entries(chartData)) {
      //  newObj[byPeriod] = key;
      //  for (const [key2, value2] of Object.entries(value)) {
      //    newObj[key2] = value2;
      //  }
      //  data.push(newObj);
      //  newObj = {};
      //}
  
      for (var i = 0; i < periodValues.length; i++) {
        newObj[byPeriod] = periodValues[i];
        data.push(Object.assign(newObj, chartData[periodValues[i]]));
        newObj = {};
      } 
  
      return (
        <div>
          <ToastContainer />
           <div id="analytics" style={{ width: "990px", height: "580px" }} >
              <div style={{ width:"990px", margin: "0", padding: "10px", display: "flex", justifyContent: "center", backgroundColor: "#f0f0f2" }} >
                <form className="switch-area" style={{ margin: "0" }} >
                  <input
                    type="radio"
                    id="switch_left"
                    name="orderTypeToggle"
                    value={this.props.leftLabel}
                    onChange={this.handleToggle}
                    checked={!this.state.orderTypeToggle}
                  />
                  <label htmlFor="switch_left">Order Value (USD)</label>
  
                  <input
                    type="radio"
                    id="switch_right"
                    name="orderTypeToggle"
                    value={this.props.rightLabel}
                    onChange={this.handleToggle}
                    checked={this.state.orderTypeToggle}
                  />
                  <label htmlFor="switch_right">Order Count</label>
                </form>
              </div>
              <div id="barcharBox" style={{ width: "990px", height: "500px", backgroundColor: "#fafafa" }}>
              {status == 'L' ?
              <div style={{ display: "flex", justifyContent: "center", height: "100%" }}>
                <div style={{ alignSelf: "center"}}>
                  <BasicAlert type="L" />
                </div>
              </div>
              : <Bar
                  width={990}
                  height={500}
                  margin={{ top: 30, right: 30, bottom: 40, left: 90 }}
                  label={d => fmCompactNum(parseInt(d.value))}
                  axisLeft={{"format": (d) => fmCompactNum(parseInt(d))}}
                  tooltip={({ id, value, indexValue }) => (
                    <div className="barChartToolTip">{fmNum(value)}</div>
                  )}
                  data={data}
                  colors={["#0096d6"]}
                  //colors={{ scheme: 'blues' }}
                  //colorBy={colorBy}
                  indexBy={byPeriod}
                  //keys={["Submitted", "Processing", "Shipped", "Delivered"]}
                  keys={[orderStatus]}
                  labelTextColor="white"
                  enableGridX={false}
                  theme={{
                    axis: {
                      ticks: {
                        line: {
                          stroke: "grey"
                        },
                        text: {
                          fill: "gray"
                        }
                      }
                    },
                    //for some reason, below code works not with our installed nivo/bar version
                    //thats why we instead use a css class declared in oswidget.css
                    tooltip: {
                      container: {
                          background: "#ffffff",
                          color: "#333333",
                          fontSize: 12
                      },
                    }
                  }}
                />
              }
              </div>
              <div style={{ width: "990px", display: "flex", justifyContent: "space-between", backgroundColor: "#f0f0f2"}}>
                <div className="dropdown-area">
                  <label htmlFor="periodOptions">Period</label>
                  <select name="periodOptions"  onChange={this.handleSelect}>
                    <option value="quarter">Quarter</option>
                    <option value="month">Month</option>
                  </select>
                </div>
                <div className="dropdown-area">
                  <label htmlFor="orderStatusOptions">Order Status</label>
                  <select name="orderStatusOptions"  onChange={this.handleSelect}>
                    <option value="total">Total</option>
                    <option value="Submitted">Submitted</option>
                    <option value="Processing">Processing</option>
                    <option value="Shipped">Shipped</option>
                    <option value="Delivered">Delivered</option>
                  </select>
                </div>
                <div className="dropdown-area">
                  <label htmlFor="orderBacklog">Order Backlog</label>
                  <select name="orderBacklog"  onChange={this.handleSelect}>
                    <option value="allOrders">All Orders</option>
                    <option value="myOrders">My Orders</option>
                  </select>
                </div>
              </div>
  
          </div>
        </div>
      )
    }
  };